// Config/siteRoutes.js
import InfoPage from '../Pages/InfoPage';
import LaunchPage from '../Pages/LaunchPage';
import GamesPage from '../Pages/GamesPage';
import SettingsPage from '../Pages/SettingsPage';
import FeaturesPage from '../Pages/FeaturesPage';
import MonitoringPage from '../Pages/MonitoringPage';
import OrdersPage from '../Pages/OrdersPage';
import BetSettingsPage from '../Pages/BetSettingsPage';
import Home from '../Pages/Home';

export const SiteRoutes = [
    {
        path: '/Information',
        element: InfoPage,
        requiresAuth: true,
    },
    {
        path: '/Launch',
        element: LaunchPage,
        requiresAuth: true,
    },
    {
        path: '/Games',
        element: GamesPage,
        requiresAuth: true,
    },
    {
        path: '/Settings',
        element: SettingsPage,
        requiresAuth: true,
    },
    {
        path: '/Features',
        element: FeaturesPage,
        requiresAuth: true,
    },
    {
        path: '/Monitoring',
        element: MonitoringPage,
        requiresAuth: true,
    },
    {
        path: '/orders/*',
        element: OrdersPage,
        requiresAuth: true,
    },
    {
        path: '/BetSettings',
        element: BetSettingsPage,
        requiresAuth: true,
    },
];